/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Outcome_AcceptedInputs */

const en_claim_outcome_accepted = /** @type {(inputs: Claim_Outcome_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Claim_Outcome_AcceptedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_outcome_accepted = /** @type {((inputs?: Claim_Outcome_AcceptedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Outcome_AcceptedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_outcome_accepted(inputs)
});